
import { Request } from '../../../httpClient/serverApi/requests/Request';
import { ISingleIdParams } from '../../../ts/ServerApi/types/actionParams';
import { FlowDraftItem } from '../../../ts/ServerApi/types/resourceParts';

export type GetFlowDraftResult = FlowDraftItem;

export class GetFlowDraftRequest extends Request<ISingleIdParams, GetFlowDraftResult> {
  constructor(params: ISingleIdParams) {
    super('getFlowDraft', params);
  }
}
